import { createSelector } from 'reselect';

import { getSelectedGroupId } from 'modules/groups/selectors';
import { getSelectedDealerId } from 'selectors/dealerSelectors';

const getProps = (_, props) => props;

export const getBaseParameters = createSelector(
  getSelectedDealerId,
  getSelectedGroupId,
  getProps,
  (dealerId, groupId, isGroupConfig) => (isGroupConfig ? { groupId } : { dealerId })
);
